import React, { useState, useEffect, useContext, useRef } from 'react'
import MyNavBar from '../myComponents/MyHeader/MyNavBar'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import IndexList from '../myComponents/IndexList/IndexList'
import * as Styles from './BindPageStyle'
import StaffIcon from '../Icons/StaffIcon'
import { List, InputItem, Picker, Toast, Icon } from 'antd-mobile'
import './BindPageCss.css'
import intl from 'react-intl-universal'
import People from '../Icons/People'
import MyDoctor from '../Icons/MyDoctor'
import Stethoscope from '../Icons/Stethoscope'
import Hospital from '../Icons/Hospital'
import Address from '../Icons/Address'
import Bed from '../Icons/Bed'
import AllergenIcon from '../Icons/Allergen'
import DeleteIcon from '../Icons/DeleteIcon'
import MyModal from '../myComponents/MyModal/MyModal'
import request from '../../utils/request'
import { Session } from '../../contexts/Session'
import { HospitalBasicInfoContext } from '../../contexts/HospitalBasicInfo'
import { LanguageContext } from '../../contexts/LanguageContext'
import config from '../../config'

export default function BindPage (props) {
  const [number, setNumber] = useState('') // 住院号
  const [patientName, setPatientName] = useState('') // 病员姓名
  const [selectedDietaryAdvice, setSelectedDietaryAdvice] = useState([]) // 饮食医嘱(只有value)
  const [selectedDietaryAdviceObj, setSelectedDietaryAdviceObj] = useState([]) // 饮食医嘱(既有value也有id)
  const [floor, setFloor] = useState({}) // 楼层
  const [area, setArea] = useState([]) // 病区
  const [bedId, setBedId] = useState({}) // 床位号
  const [selectedPosition, setSelectedPosition] = useState([]) // 用户选择的床位数组
  const [allergen, setAllergen] = useState('') // 过敏源

  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [modalTitle, setModalTitle] = useState('') // 提示信息弹窗的提示标题内容

  const [numberEditable, setNumberEditable] = useState(true) // 住院号是否可编辑
  const [editable, setEditable] = useState(true) // 用户当前页面除去住院号和床位的文本框是否可编辑
  const [positionEditable, setPositionEditable] = useState(true) // 床位信息是否可编辑
  const [showOKButton, setShowOKButton] = useState(true) // 住院号后面的确定按钮是否显示

  const [confirmNumber, setConfirmNumber] = useState(false) // 住院号是否高亮
  const [confirmName, setConfirmName] = useState(false) // 姓名是否高亮
  const [confirmDietaryAdvice, setConfirmDietaryAdvice] = useState(false) // 饮食医嘱是否高亮
  const [confirmPosition, setConfirmPosition] = useState(false) // 病区楼层床位号是否高亮

  // const [foodAdviceOptions, setFoodAdviceOptions] = useState([]) // 饮食医嘱的option标签数组
  const [floorsArr, setFloorsArr] = useState([]) // 从后台读取的所有楼层数组
  const [dataSource, setDataSource] = useState([]) // 该医院的所有位置数组(包含了病区，楼层，床位的所有数据)，会根据用户的选择动态变化
  const SessionContext = useContext(Session) // 包含了病员信息，用户信息(JSON格式)context
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext) // 医院基础信息context
  const Language = useContext(LanguageContext) // 医院基础信息context

  const bindButton = useRef('bindButton') // 绑定按钮ref
  const [visible, setVisible] = useState(false)
  const [defaultValue, setDefaultValue] = useState([])
  const [foodAdviceDataSource, setFoodAdviceDataSource] = useState([]) // 饮食医嘱的option标签数组

  const [patientInfoArray, setPatientInfoArray] = useState([]) // 根据床头二维码获得的病员信息
  const [pickerData, setPickerData] = useState([]) // 选择病员的弹窗（PickerView）数据源
  const [ifShowPickerView, setIfShowPickerView] = useState(false) // 是否展示选择病员的弹窗（PickerView）
  const [selectedPatient, setSelectedPatient] = useState({})
  const [showPatientInfoModal, setShowPatientInfoModal] = useState(false) // 展示多个病员中被选中的病员信息
  const [showRefuseToChoosePatientModal, setShowRefuseToChoosePatientModal] = useState(false) // 提示用户是否确定提供的数据中没有他要绑定的病人信息

  const [flag, setFlag] = useState(false)
  const [initDeviceHeight, setInitDeviceHeight] = useState(0) // 刚进入页面时手机可视区域的高度
  const [height, setHeight] = useState(0) // 刚进入页面时手机可视区域的高度
  const inputRef = useRef('inputRef')

  useEffect(() => {
    setInitDeviceHeight(window.innerHeight)
    setHeight(window.innerHeight)
    inputRef.current.onInputBlur = () => {
      window.scroll(0, 0)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (initDeviceHeight > 0) {
      setIOSAndroidBody()
    }
    // eslint-disable-next-line
  }, [initDeviceHeight])

  useEffect(() => {
    if (JSON.stringify(HospitalBasicInfo.hospitalBasicInfo) !== '{}') {
      // renderFoodAdvicesOptions()
      getAllFloors()
      fuliterFoodAdvice()
    }
    // eslint-disable-next-line
  }, [HospitalBasicInfo])

  function setIOSAndroidBody () {
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
    // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isAndroid) {
      window.onresize = function () {
        // 键盘弹起与隐藏都会引起窗口的高度发生变化
        var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (resizeHeight - 0 < initDeviceHeight - 0) {
          // 当软键盘弹起，在此处操作
          // this.alert(resizeHeight)
          setHeight(resizeHeight)
        } else {
          // 当软键盘收起，在此处操作
          setHeight(initDeviceHeight)
        }
      }
    }
  }

  function fuliterFoodAdvice () {
    const foodAdvices = HospitalBasicInfo.hospitalBasicInfo.foodAdvices
    const dataSource = []
    foodAdvices.map((item) => {
      const tempObj = {}
      tempObj.value = item.id
      tempObj.label = item.advice
      tempObj.spell = item.spell
      dataSource.push(tempObj)
    })
    setFoodAdviceDataSource(dataSource)
  }

  /**
   * 根据Seesion中的数据，填充以及判断用户是否能输入
   */
  useEffect(() => {
    if (!flag) {
      // console.log(SessionContext)
      let patientInfo = {}
      let tempPatientArray = [...SessionContext.patientInfo] // 存放由床头二维码获取的病员信息
      // if (tempPatientArray.length === 1) { // 说明床头二维码只获得一个用户信息
      //   patientInfo = tempPatientArray[0]
      //   setPatientInfoArray([...tempPatientArray])
      //   setPickerData([...tempPatientArray])
      //   setIfShowPickerView(false)
      // } else
      if (tempPatientArray.length >= 1) { // 说明床头二维码获得了一个或多个用户信息
        tempPatientArray = [...tempPatientArray]
        let result = []
        result = tempPatientArray.map((patient) => {
          // eslint-disable-next-line
          return { label: `${patient.pid}　　${patient.patientName}`, value: patient.pid }
        })
        setPickerData([...result])
        setPatientInfoArray([...tempPatientArray])
        setIfShowPickerView(true)
      } else { // 说明床头二维码没有获得用户信息
        patientInfo = SessionContext.patientInfoByWristband
        tempPatientArray = []
        setPatientInfoArray([])
        setPickerData([])
        setIfShowPickerView(false)
      }
      if (tempPatientArray.length > 1) { // 说明床头二维码获得的用户信息为多个

      } else { // 说明床头二维码获得的用户信息为1个或0个
        if (JSON.stringify(patientInfo) !== '{}') { // 说明：此类情况下，用户一定是通过床头二维码或腕带已经获取了病员信息
          setPatientInfo(patientInfo) // 填充病员所有信息
          setNumberEditable(false) // 禁止修改住院号
          setEditable(false) // 禁止修改用户名和饮食医嘱
          setPositionEditable(false) // 禁止修改床位信息
        } else { // 此类情况下，用户未通过床头二维码或腕带获取病员信息
          if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo) {
            if (JSON.stringify(SessionContext.positionInfo) !== '{}') { // 此类情况，虽然用户没有病员具体信息，但是通过床头二维码获取了用户的床位信息
              setPatientPositionInfo() // 填充病员的床位信息
              setPositionEditable(false) // 禁止用户修改床位信息
              if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
                setNumberEditable(true) // 允许修改住院号
                setEditable(false) // 禁止修改用户名和饮食医嘱
              } else {
                setNumberEditable(true) // 允许修改住院号
                setEditable(true) // 允许修改用户名和饮食医嘱
              }
            } else { // 此类情况，用户通过公众号进入系统，且没有病员的任何信息
              setNumberEditable(true) // 允许修改住院号
              if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
                setPositionEditable(false) // 禁止用户修改床位信息
                setEditable(false) // 禁止修改用户名和饮食医嘱
              } else {
                setPositionEditable(true) // 允许用户修改床位信息
                setEditable(true) // 允许修改用户名和饮食医嘱
              }
            }
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [SessionContext, HospitalBasicInfo])

  /**
   * 用户选择病员
   */
  function handleOnSelectPatient (value) {
    let patient = {}
    patient = patientInfoArray.filter((patient) => patient.pid === value[0])[0]
    const patientInfoDom = <table style={{ width: '100%' }}>
      <tbody align='left'>
        <tr>
          <td>{intl.get('PatientName')}</td>
          <td>{patient.patientName}</td>
        </tr>
        <tr>
          <td colSpan={2} style={{ borderBottom: '1px solid #EFEFEF' }} />
        </tr>
        <tr>
          <td>{intl.get('HospitalizationNumber')}</td>
          <td>{patient.pid}</td>
        </tr>
      </tbody>
    </table>
    setIfShowPickerView(false)
    setShowPatientInfoModal(true)
    setModalTitle(intl.get('SureToChoosePatient'))
    setModalInfo(patientInfoDom)
    setSelectedPatient(patient)
  }

  /**
   * 根据床位号查询出的病人信息不包括用户想绑定的人
   */
  function handleOnRefuseChoosePatient () {
    setIfShowPickerView(false)
    setShowRefuseToChoosePatientModal(true)
    setModalTitle(intl.get('Tips'))
    setModalInfo(intl.get('SureToRefuseToChoosePatient'))
  }

  /**
   * 自动填充病员信息
   */
  function setPatientInfo (patientData) {
    const patientInfo = patientData
    const temp = []
    const tempObj = []
    const tempId = []
    patientInfo.foodAdvices.map((advice) => {
      temp.push(advice.advice)
      tempObj.push({ id: advice.id, value: advice.advice })
      tempId.push(advice.id)
    })
    setNumber(patientInfo.pid)
    setFloor({ floorId: patientInfo.lc_ID, floorName: patientInfo.lc_Name })
    setArea({ areaId: patientInfo.bq_ID, areaName: patientInfo.bq_Name })
    setBedId({ bedId: patientInfo.patPositionID, bedName: patientInfo.patPositionName })
    setPatientName(patientInfo.patientName)
    setAllergen(patientInfo.allergies)
    setSelectedDietaryAdvice(temp)
    setSelectedDietaryAdviceObj(tempObj)
    setDefaultValue(tempId)
    setEditable(false)
    setShowOKButton(false)
  }

  function setPatientPositionInfo () {
    const positionInfo = SessionContext.positionInfo
    setFloor({ floorId: positionInfo.lc_ID, floorName: positionInfo.lc_Name })
    setArea({ areaId: positionInfo.bq_ID, areaName: positionInfo.bq_Name })
    setBedId({ bedId: positionInfo.patPositionID, bedName: positionInfo.patPositionName })
  }

  /**
   * 重定向到微信授权页面
   */
  function redirectToAuth () {
    const hisCode = window.localStorage.getItem('sdxHisCode') ? window.localStorage.getItem('sdxHisCode') : ''
    const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId') ? `/${window.localStorage.getItem('sdxPatPositionId')}` : ''
    const indexUrl = `/index/${hisCode}${sdxPatPositionId}`
    Toast.info(
      intl.get('RedirectToAuth'), 2,
      () => {
        // console.log(`即将跳转${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        // window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=${indexUrl}`)
      }, true)
  }

  /**
   * 获取所有的楼层
   */
  function getAllFloors (floorIndex = 0, areaIndex = 0) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/lc`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        setFloorsArr(res.data.slice(0))
        getAreasByFloor(res.data, floorIndex, areaIndex)
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          Toast.info('获取所有病区出错')
        }
      } else {
        Toast.info('获取所有病区出错')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据用户选择的楼层去获取该楼层的所有病区
   */
  function getAreasByFloor (floorsTemp, floorIndex, areaIndex) {
    Toast.loading('', 0, () => { }, true)
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/${floorsTemp[floorIndex].id}/bq`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          getBedsByFloor(floorsTemp, res.data, floorIndex, areaIndex)
        } else {
          Toast.hide()
          Toast.info(intl.get('NoWardInfo'), 1)
        }
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          Toast.hide()
          Toast.info(intl.get('NoWardInfo'), 1)
        }
      } else {
        Toast.hide()
        Toast.info(intl.get('NoWardInfo'), 1)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据用户选择的楼层去获取该楼层的所有床位
   */
  function getBedsByFloor (floorsTemp, areas, floorIndex, areaIndex) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/lc/${areas[areaIndex].id}/patposition`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          handleOnGetPickerData(floorsTemp, areas, res.data, floorIndex, areaIndex)
        } else {
          Toast.hide()
          Toast.info(intl.get('NoBedInfo'), 1)
        }
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          Toast.hide()
          Toast.info(intl.get('NoBedInfo'), 1)
        }
      } else {
        console.log(res)
        Toast.hide()
        Toast.info(intl.get('NoBedInfo'), 1)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 返回Picker组件需要的格式的数据
   */
  function handleOnGetPickerData (floorsTemp, areas, beds, floorIndex, areaIndex) {
    const floorsArr = []
    floorsTemp.map((floor, index) => {
      const floorObj = {}
      floorObj.label = <div>{floor.name}</div>
      floorObj.value = JSON.stringify({ floorId: floor.id, floorName: floor.name, index: index })
      if (index === floorIndex) {
        const areaArr = []
        areas.map((area, j) => {
          const areaObj = {}
          areaObj.label = <div>{area.name}</div>
          areaObj.value = JSON.stringify({ areaId: area.id, areaName: area.name, index: j })
          if (j === areaIndex) {
            const bedArr = []
            beds.map((bed) => {
              const bedObj = {}
              bedObj.label = <div>{bed.name}</div>
              bedObj.value = JSON.stringify({ bedId: bed.id, bedName: bed.name })
              bedArr.push(bedObj)
            })
            areaObj.children = bedArr
          } else {
            areaObj.children = []
          }
          areaArr.push(areaObj)
        })
        floorObj.children = areaArr
      } else {
        floorObj.children = []
      }
      floorsArr.push(floorObj)
    })
    Toast.hide()
    setDataSource(floorsArr)
  }
  // console.log(Language)

  /**
   * 点击住院号的确认按钮
   */
  function handleOnClickConfirm () {
    if (number.length <= 0) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterPID'))
    } else {
      getPatientInfoByPId()
    }
  }

  /**
   * 重置所有input的状态
   */
  function resetInputEditState (params) {
    let patientInfo = {}
    if (SessionContext.patientInfo.length !== 0) {
      patientInfo = SessionContext.patientInfo
    } else {
      patientInfo = SessionContext.patientInfoByWristband
    }
    if (JSON.stringify(patientInfo) !== '{}') { // 说明：此类情况下，用户一定是通过床头二维码或腕带已经获取了病员信息
      setPatientInfo(patientInfo) // 填充病员所有信息
      setNumberEditable(false) // 禁止修改住院号
      setEditable(false) // 禁止修改用户名和饮食医嘱
      setPositionEditable(false) // 禁止修改床位信息
    } else { // 此类情况下，用户未通过床头二维码或腕带获取病员信息
      if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo) {
        if (JSON.stringify(SessionContext.positionInfo) !== '{}') { // 此类情况，虽然用户没有病员具体信息，但是通过床头二维码获取了用户的床位信息
          setPatientPositionInfo() // 填充病员的床位信息
          setPositionEditable(false) // 禁止用户修改床位信息

          setPatientName('')
          setAllergen('')
          setSelectedDietaryAdvice([])
          setSelectedDietaryAdviceObj([])
          setDefaultValue([])

          if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
            setNumberEditable(true) // 允许修改床位号
            setEditable(false) // 禁止修改用户名和饮食医嘱
          } else {
            setNumberEditable(true) // 允许修改床位号
            setEditable(true) // 允许修改用户名和饮食医嘱
          }
        } else { // 此类情况，用户通过公众号进入系统，且没有病员的任何信息
          setFloor({})
          setArea({})
          setBedId({})
          setPatientName('')
          setAllergen('')
          setSelectedDietaryAdvice([])
          setSelectedDietaryAdviceObj([])
          setDefaultValue([])

          setNumberEditable(true) // 允许修改住院号
          if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
            setPositionEditable(false) // 禁止用户修改床位信息
            setEditable(false) // 允许修改用户名和饮食医嘱
          } else {
            setPositionEditable(true) // 禁止用户修改床位信息
            setEditable(true) // 允许修改用户名和饮食医嘱
          }
        }
      }
    }
  }

  /**
   * 根据住院号获取病员信息
   */
  function getPatientInfoByPId () {
    const sdxHisCode = window.localStorage.getItem('sdxHisCode')
    request(`/v1/patients/${number}?hospitalId=${sdxHisCode}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      // console.log(res)
      if (!res.error) {
        if (res.data.id === undefined) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterPIDAgain'))
          // setFloor({})
          // setArea({})
          // setBedId({})
          // setPatientName('')
          // setSelectedDietaryAdvice([])
          // setSelectedDietaryAdviceObj([])
          // setDefaultValue([])
          setConfirmNumber(false)
          setConfirmName(false)
          setConfirmDietaryAdvice(false)
          setConfirmPosition(false)

          // if (!HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
          //   setEditable(true)
          //   setPositionEditable(true)
          // } else {
          //   setEditable(false)
          //   setPositionEditable(false)
          // }
          resetInputEditState() // 重新设置输入框的是否可编辑状态
        } else {
          const temp = []
          const tempObj = []
          const tempId = []
          res.data.foodAdvices.map((advice) => {
            temp.push(advice.advice)
            tempObj.push({ id: advice.id, value: advice.advice })
            tempId.push(advice.id)
          })
          // setPatientIDInfo(res.data)
          setFloor({ floorId: res.data.lc_, floorName: res.data.lc_Name })
          setArea({ areaId: res.data.bq_ID, areaName: res.data.bq_Name })
          setBedId({ bedId: res.data.patPositionID, bedName: res.data.patPositionName })
          setPatientName(res.data.patientName)
          setAllergen(res.data.allergies)
          setSelectedDietaryAdvice(temp)
          setSelectedDietaryAdviceObj(tempObj)
          setDefaultValue(tempId)
          setEditable(false)
          setPositionEditable(false)
          setConfirmNumber(false)
          setConfirmName(false)
          setConfirmDietaryAdvice(false)
          setConfirmPosition(false)
        }
      } else {
        if (['1001', '1002', '1003'].includes(res.code)) {
          // setFloor({})
          // setArea({})
          // setBedId({})
          // setPatientName('')
          // setSelectedDietaryAdvice([])
          // setSelectedDietaryAdviceObj([])
          // setDefaultValue([])
          setConfirmNumber(false)
          setConfirmName(false)
          setConfirmDietaryAdvice(false)
          setConfirmPosition(false)

          resetInputEditState()
          // if (!HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
          //   setEditable(true)
          //   setPositionEditable(true)
          // } else {
          //   setEditable(false)
          //   setPositionEditable(false)
          // }
          if (Number(res.code) === 1001) {
            setShowModal(true)
            // setModalInfo(intl.get('QueryPetientInfo1001'))
            setModalTitle(intl.get('Tips'))
            setModalInfo(res.message)
          } else if (Number(res.code) === 1002) {
            setShowModal(true)
            // setModalInfo(intl.get('QueryPetientInfo1002'))
            setModalTitle(intl.get('Tips'))
            setModalInfo(res.message)
          } else if (Number(res.code) === 1003) {
            setShowModal(true)
            // setModalInfo(intl.get('QueryPetientInfo1003'))
            setModalTitle(intl.get('Tips'))
            setModalInfo(res.message)
          } else {
            console.log(res.message)
          }
        } else if (res.code) {
          if (Number(res.code) === 2000) {
            redirectToAuth()
          } else {
            console.log(res.message)
          }
        } else {
          console.log(res.message)
        }
        // Toast.info('获取该病员信息出错!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 返回文本框的删除按钮
   */
  function RenderDeleteIcon (props) {
    const { type } = props
    return (
      type && type.toString().length && editable > 0 ? <Styles.DeleteIconContainer onClick={props.onClick}><DeleteIcon width={20} height={20} /></Styles.DeleteIconContainer> : null
    )
  }

  /**
   * 返回住院号的确认按钮
   */
  function RenderNumberConfirmButton () {
    return (
      <Styles.NumberConfirmButton onClick={(obj) => handleOnClickConfirm(obj)}>{intl.get('Search')}</Styles.NumberConfirmButton>
    )
  }

  /**
   * 床位选择点击取消触发事件
   */
  // function handlePickerOnCancel () {
  //   console.log(123)
  //   setSelectedPosition([])
  //   setConfirmPosition(true)
  //   setArea({})
  //   setFloor({})
  //   setBedId({})
  // }

  /**
   * 床位选择点击确定触发事件
   */
  function handlePickerOnOk (value) {
    setSelectedPosition(value)
    if (value.length === 3) {
      setConfirmPosition(false)
      setFloor(JSON.parse(value[0]))
      setArea(JSON.parse(value[1]))
      setBedId(JSON.parse(value[2]))
    } else {
      setConfirmPosition(true)
    }
  }

  /**
   * 当用户更改每一列的选择时改变其他列的显示数据
   * 病区->楼层->床位
   */
  function handleOnColChange (value) {
    setSelectedPosition(value)
    let areaIndex = 0
    let floorIndex = 0
    value.map((item, index) => {
      const itemObj = JSON.parse(item)
      if (index === 0) {
        floorIndex = itemObj.index
      }
      if (index === 1) {
        areaIndex = itemObj.index
      }
    })
    getAreasByFloor(floorsArr.slice(0), floorIndex, areaIndex)
  }

  /**
   * 当用户选择饮食医嘱时触发
   */
  // function handleOnSelectChange (e) {
  //   const obj = document.getElementById('foodAdvices')
  //   const temp = []
  //   const tempObj = []
  //   for (let i = 0; i < obj.options.length; i++) {
  //     if (obj.options[i].selected) {
  //       temp.push(obj.options[i].value)
  //       tempObj.push({ id: obj.options[i].id, value: obj.options[i].value })
  //     }
  //   }
  //   if (tempObj.length > 0) {
  //     setConfirmDietaryAdvice(false)
  //   } else {
  //     setConfirmDietaryAdvice(true)
  //   }
  //   setSelectedDietaryAdvice(temp)
  //   setSelectedDietaryAdviceObj(tempObj)
  // }

  /**
   * 点击确认绑定按钮触发
   */
  function handleOnBind () {
    // console.log(number)
    // console.log(patientName)
    // console.log(selectedDietaryAdvice)
    // console.log(selectedDietaryAdviceObj)
    // console.log(area)
    // console.log(floor)
    // console.log(bedId)
    if (numberEditable) {
      if (number.length === 0) {
        setShowModal(true)
        setModalTitle(intl.get('Tips'))
        setModalInfo(intl.get('EnterPID'))
        setConfirmNumber(true)
        return false
      }
      if (editable) {
        if (patientName.length === 0) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterPName'))
          setConfirmName(true)
          return false
        }
        if (selectedDietaryAdvice.length === 0) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterFoodAdvice'))
          setConfirmDietaryAdvice(true)
          return false
        }
      }
      if (positionEditable) {
        if (!bedId.bedId) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterBedInfo'))
          setConfirmPosition(true)
          return false
        } else {
          if (bedId.bedId.length === 0) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(intl.get('EnterBedInfo'))
            setConfirmPosition(true)
            return false
          }
        }
      }
    }
    bindButton.current.disabled = true // 当用户点击了一次绑定按钮后绑定按钮失效
    Toast.loading('', 0)
    const data = {}
    data.PID = number // 住院号
    const foodAdviceIdsTemp = [] // 饮食医嘱的数组
    selectedDietaryAdviceObj.map((advice) => {
      foodAdviceIdsTemp.push(advice.id)
    })
    data.foodAdviceIds = foodAdviceIdsTemp.join(' ')
    data.hisCode = HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode // 医院的hisCode
    data.patPositionID = bedId.bedId // 床位号
    data.patientName = patientName // 病员名称
    data.type = 'type' // 病员名称
    request(`/v1/orderers/bind?PID=${data.PID}&foodAdviceIds=${data.foodAdviceIds}&hisCode=${data.hisCode}&patPositionID=${data.patPositionID}&patientName=${data.patientName}&type=${data.type}`, {
      // request(`/v1/orderers/bind`, {
      method: 'POST',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      // console.log(res)
      Toast.hide()
      if (!res.error) {
        if (res.data.language) {
          Language.setLocale(res.data.language)
        }
        // const sdxHisCode = window.localStorage.getItem('sdxHisCode')
        // const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
        // if (sdxPatPositionId) {
        //   props.history.push(`/index/${sdxHisCode}/${sdxPatPositionId}`)
        // } else {
        //   props.history.push(`/index/${sdxHisCode}`)
        // }
        props.history.push('/order')
        SessionContext.setBinded(true)
        SessionContext.setLogged(true)
        SessionContext.setCurrentUser(res.data)
      } else {
        if (['1501', '1502', '1503', '1504', '1505', '1087', '1088', '1089', '1041', '1506', '1507', '1021', '1042'].includes(res.code)) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(res.message)
          bindButton.current.disabled = false // 当用户绑定失败时，重新启用绑定按钮
        } else {
          bindButton.current.disabled = false // 当用户绑定失败时，重新启用绑定按钮
          console.log(res)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  function getSelectedFood (foodObj) {
    if (foodObj.length > 0) {
      setConfirmDietaryAdvice(false)
    } else {
      setConfirmDietaryAdvice(true)
    }
    const selectedValue = []
    const selectedAdvice = []
    const foodObjTemp = []
    foodObj.map((item) => {
      selectedValue.push(item.value)
      selectedAdvice.push(item.label)
      foodObjTemp.push({ id: item.value, value: item.label })
    })
    setDefaultValue(selectedValue)
    setSelectedDietaryAdvice(selectedAdvice)
    setSelectedDietaryAdviceObj(foodObjTemp)
    setVisible(false)
  }

  function handleOnCancel () {
    setVisible(false)
  }

  return (
    <Styles.Container style={{ height: `${height}px` }}>
      <Styles.NavBarContainer>
        <MyHeaderBg />
        <MyNavBar
          Icon={<Icon size={'md'} color={'white'} type={'left'} />}
          rightContent={<Icon size={'md'} color={'white'} type={'cross'} />}
          history={props.history}
          titleStyle={{ fontFamily: 'YouYuan', fontSize: '1.125rem' }}
        >
          {intl.get('Binding patient')}
        </MyNavBar>
        <Styles.TelephoneServiceContainer>
          <Styles.IconContainer>
            <StaffIcon width={'30%'} />
          </Styles.IconContainer>
          <Styles.TelephoneTextContainer>
            {intl.get('Service Hotline')}:
            {
              HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo
                ? <a style={config.theme && { color: config.theme.textColor }} href={`tel:${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.telephone}`}>
                  <u>{HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.telephone}</u>
                </a>
                : ''
            }
          </Styles.TelephoneTextContainer>
        </Styles.TelephoneServiceContainer>
      </Styles.NavBarContainer>
      <Styles.ListContainer id='haha' style={{ height: `${initDeviceHeight}px` }}>
        <Styles.ListTitle>
          {intl.get('Patient information registration')}
        </Styles.ListTitle>
        <List prefixCls={'myList'} className={'myBindList'}>
          {/** 住院号 */}
          <InputItem
            ref={inputRef}
            editable={numberEditable}
            value={number}
            className={'myInput'}
            labelNumber={3}
            placeholder={intl.get('HospitalizationNumber')}
            extra={showOKButton ? <RenderNumberConfirmButton /> : null}
            onChange={(value) => {
              setNumber(value)
              // setFloor({})
              // setArea({})
              // setBedId({})
              // setPatientName('')
              // setSelectedDietaryAdvice([])
              // setSelectedDietaryAdviceObj([])
              // setDefaultValue([])
              // if (!HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
              //   setEditable(true)
              //   setPositionEditable(true)
              // } else {
              //   setEditable(false)
              //   setPositionEditable(false)
              // }
              if (value && value.length > 0) {
                setConfirmNumber(false)
              } else {
                setConfirmNumber(true)
              }

              // resetInputEditState() // 当住院号发生变化的时候重置其他所有输入框的状态
            }}
          >
            <Stethoscope width='40%' color={confirmNumber ? 'red' : undefined} />
          </InputItem>
          {/** 病员姓名 */}
          <InputItem
            editable={editable}
            className={'myInput'}
            value={patientName}
            onChange={(value) => {
              setPatientName(value)
              if (value && value.length > 0) {
                setConfirmName(false)
              } else {
                setConfirmName(true)
              }
            }}
            labelNumber={3}
            placeholder={intl.get('PatientName')}
            onExtraClick={editable ? () => setPatientName('') : () => { }}
            extra={<RenderDeleteIcon type={patientName} />}
          >
            <People width='40%' color={confirmName ? 'red' : undefined} />
          </InputItem>
          {/** 饮食医嘱 */}
          <InputItem
            className={'myInput'}
            editable={false}
            value={selectedDietaryAdvice}
            labelNumber={3}
            placeholder={intl.get('DietaryAdvice')}
            // extra={<select
            //   placeholder={'请选择'}
            //   id={'foodAdvices'}
            //   name={'foodAdvices'}
            //   disabled={!editable}
            //   multiple='multiple'
            //   className={'mySelect'}
            //   value={selectedDietaryAdvice}
            //   onChange={handleOnSelectChange}>
            //   {foodAdviceOptions}
            // </select>}
            extra={editable ? <div onClick={() => setVisible(true)}>{intl.get('ChooseFoodeAdviceTip')}</div> : null}
          >
            <MyDoctor width={'40%'} color={confirmDietaryAdvice ? 'red' : undefined} />
          </InputItem>

          {/* 过敏源Allergen */}
          <InputItem
            editable={false}
            className={'myInput'}
            labelNumber={3}
            value={allergen}
            onChange={(value) => {
              setAllergen(value)
            }}
            placeholder={intl.get('Allergen')}
          >
            <AllergenIcon width='40%' />
          </InputItem>

          <Picker
            okText={intl.get('OK')}
            dismissText={intl.get('Cancel')}
            onPickerChange={(value) => handleOnColChange(value)}
            disabled={!positionEditable}
            cols={3}
            data={dataSource}
            title={intl.get('PositionPickerTitle')}
            cascade
            value={selectedPosition}
            onOk={(value) => handlePickerOnOk(value)}
            itemStyle={{ fontSize: '0.8rem' }}
          // onDismiss={() => handlePickerOnCancel()}
          >
            <div>
              {/** 楼层 */}
              <InputItem
                editable={false}
                className={'myRegisterInput'}
                value={floor.floorName}
                labelNumber={3}
                placeholder={intl.get('Floor')}
                extra={null}
                style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
              >
                <Hospital width={'40%'} color={confirmPosition ? 'red' : undefined} />
              </InputItem>
              {/** 病区 */}
              <InputItem
                editable={false}
                className={'myRegisterInput'}
                value={area.areaName}
                labelNumber={3}
                placeholder={intl.get('InpatientWard')}
                extra={null}
                style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
              >
                <Address width={'40%'} color={confirmPosition ? 'red' : undefined} />
              </InputItem>
              {/** 床位 */}
              <InputItem
                editable={false}
                className={'myRegisterLastInput'}
                value={bedId.bedName}
                labelNumber={3}
                placeholder={intl.get('BedID')}
                extra={null}
                style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
              >
                <Bed width={'40%'} color={confirmPosition ? 'red' : undefined} />
              </InputItem>
            </div>
          </Picker>
        </List>
        <Styles.ConfirmButton
          ref={bindButton}
          onClick={() => handleOnBind()}
        >
          {intl.get('Confirm')}
        </Styles.ConfirmButton>
      </Styles.ListContainer>
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={false}
        onOkClick={() => setShowModal(false)}
      />
      <IndexList
        defaultValue={defaultValue}
        visible={visible}
        dataSource={foodAdviceDataSource}
        handleOnOkClick={(foodObj) => getSelectedFood(foodObj)}
        handleOnCancelClick={(foodObj) => getSelectedFood(foodObj)}
        onCancel={() => handleOnCancel()}
      />
      <MyModal
        visible={showPatientInfoModal}
        title={modalTitle}
        info={modalInfo}
        cancelButtonVisible
        onCancelClick={() => {
          setIfShowPickerView(true)
          setShowPatientInfoModal(false)
        }}
        onOkClick={() => { // 确定选择某个病人
          setShowPatientInfoModal(false)
          setFlag(true)
          SessionContext.setPatientInfo([selectedPatient])
          setPatientInfo(selectedPatient) // 填充病员所有信息
          setNumberEditable(false) // 禁止修改住院号
          setEditable(false) // 禁止修改用户名和饮食医嘱
          setPositionEditable(false) // 禁止修改床位信息
        }}
      />
      <MyModal
        visible={showRefuseToChoosePatientModal}
        title={modalTitle}
        info={modalInfo}
        cancelButtonVisible
        onCancelClick={() => {
          setIfShowPickerView(true)
          setShowRefuseToChoosePatientModal(false)
        }}
        onOkClick={() => {
          setShowRefuseToChoosePatientModal(false)
          SessionContext.setPatientInfo([])
        }}
      />
      <Picker
        title={<div style={{ fontSize: '1.2rem' }}>{intl.get('SelectPatient')}</div>}
        data={pickerData}
        visible={ifShowPickerView}
        cascade
        cols={1}
        onOk={(value) => handleOnSelectPatient(value)}
        onDismiss={() => handleOnRefuseChoosePatient()}
        okText={intl.get('OK')}
        dismissText={intl.get('Cancel')}
      />
    </Styles.Container>
  )
}
